import React from 'react';
import { Tooltip } from 'antd';
import { withTranslation } from 'react-i18next';
import { VerticalAlignBottomOutlined } from '@ant-design/icons';
import { setDisconnectMachineId, getPays, setLanguage, getLanguage } from "../util/Toolbox";
import picto_home from '../containers/assets/home/picto_home.png';
import appConfig from '../config/app.config';
import '../containers/css/navBar.css';

// URL de téléchargement de l'application Electron
const ELECTRON_DOWNLOAD_URL = 'https://spintouch.s3.fr-par.scw.cloud/Esprit-PiscineSetup.exe';

class NavBar extends React.Component {

  state = {
    language: getLanguage(),
    languages_LIST: getPays()
  }

  // Fonction pour changer la langue
  handleChangeLanguage = (event) => {
    const newLang = event.target.value;
    const { i18n } = this.props;
    i18n.changeLanguage(newLang);
    setLanguage(newLang);
    this.setState({ language: newLang });

    // Si une fonction de callback est fournie, l'appeler
    if (this.props.onLanguageChange) {
      this.props.onLanguageChange(newLang);
    }
  };

  renderUpdateIndicator() {
    const { updateStatus } = this.props;

    const indicatorStyles = {
      checking: { color: '#888' },
      available: { color: '#ff9800' }, // Orange
      current: { color: '#4caf50' },   // Vert
      error: { color: '#f44336' }      // Rouge
    };

    const style = indicatorStyles[updateStatus] || indicatorStyles.checking;

    return (
      <span
        style={{
          ...style,
          fontSize: '22px',
          marginRight: '8px',
          verticalAlign: 'middle'
        }}
      >
        <VerticalAlignBottomOutlined/>
      </span>
    );
  }

  getUpdateText() {
    const { t, updateStatus } = this.props;

    switch (updateStatus) {
      case 'checking':
        return t('menu_update_checking');
      case 'available':
        return t('menu_update_available');
      case 'current':
        return t('menu_update_current');
      case 'error':
        return t('menu_update_error');
      default:
        return t('menu_update_checking');
    }
  }

  render() {
    const { t, isElectron, updateStatus, IsAdmin } = this.props;

    return (
      <nav>
        <ul>
          <li>
            <div className='LogoNavBarContainer'>
              <a href="/"><img loading="lazy" src={picto_home} width="90px" alt="Home"/></a>
              <div className='LogoNavBar'>
                {"Produit"}
                <br/>
                <span>{"expert"}</span>
              </div>
            </div>
          </li>

          <li><a style={{ marginTop: 10 }} href="/forms">{t('menu_analyse')}</a></li>
          <li><a href="/simulateur">{t('menu_calcul_volume')}</a></li>
          <li><a href="/historique">{t('menu_historique')}</a></li>
          <li><span onClick={setDisconnectMachineId}><a href="#">{t('menu_login')}</a></span></li>

          {/* Sélecteur de langue - Contrôlé par appConfig.showLanguageSelector */}
          {appConfig.showLanguageSelector && (
            <li>
              <select
                id="language-select"
                value={this.state.language}
                disabled={false}
                onChange={this.handleChangeLanguage}
                style={{ padding: '5px', fontSize: '16px', cursor: 'pointer' }}
              >
                {this.state.languages_LIST.map((lang) => (
                  <option key={lang.code} value={lang.code}>
                    {lang.flag} {lang.label}
                  </option>
                ))}
              </select>
            </li>
          )}

          {/* Item de menu Mise à jour - Visible uniquement dans Electron */}
          {isElectron && (
            <li>
              {updateStatus === 'available' ? (
                <Tooltip title={t('menu_update_download')}>
                  <a
                    href={ELECTRON_DOWNLOAD_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontSize: 11, display: 'inline-flex', alignItems: 'center' }}
                  >
                    {this.renderUpdateIndicator()}
                    <span>{this.getUpdateText()}</span>
                  </a>
                </Tooltip>
              ) : (
                <Tooltip title={t('menu_update_app_current')}>
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      cursor: 'default',
                      color: '#2B4570',
                      fontSize: 16
                    }}
                  >
                    {this.renderUpdateIndicator()}
                    <span>{this.getUpdateText()}</span>
                  </span>
                </Tooltip>
              )}
            </li>
          )}
        </ul>
      </nav>
    );
  }
}

export default withTranslation()(NavBar);
